import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/bitacora';
import Bitacora from './Bitacora';

const mstp = state => {
    return {...state.bitacora}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(Bitacora)
